import {Box, Checkbox, TextField} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {INotificationSettings, NotificationSettings, NotificationType} from '../../../../api/api';
import {
  saveLimitSettings,
  saveEmailSettings,
  saveWebSettings,
} from '../../../../state/ducks/notification-settings/operations';
import {localized} from '../../../../state/i18n/i18n';
import {showSuccess} from '../../../../state/snackbar/operations';
import {AppState} from '../../../../state/store';
import './notification-setting-field.scss';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  saveLimitSettings: async (settings: INotificationSettings) => (await saveLimitSettings(settings))(dispatch),
  saveEmailSettings: async (settings: INotificationSettings) => (await saveEmailSettings(settings))(dispatch),
  saveWebSettings: async (settings: INotificationSettings) => (await saveWebSettings(settings))(dispatch),
  getSnackbarSuccess: () => showSuccess(localized('YourChangesAreSaved'))(dispatch),
});

const mapStateToProps = (state: AppState) => {
  return {
    successStatus: state.notificationSettingsReducer.success,
  };
};

interface PropsFromParent {
  setting: NotificationSettings;
}

interface State {
  setting: INotificationSettings;
}

type Props = Partial<ReturnType<typeof mapDispatchToProps>> &
  PropsFromParent &
  Partial<ReturnType<typeof mapStateToProps>>;

class NotificationSettingField extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      setting: this.props.setting,
    };
  }

  private changeNotification = async () => {
    let changedSettings: INotificationSettings = {...this.state.setting};
    changedSettings.emailUserWhenExceedingLimit = !changedSettings.emailUserWhenExceedingLimit;
    this.setState({setting: changedSettings});

    await this.props.saveEmailSettings!(changedSettings);
    await this.props.getSnackbarSuccess!();
  };

  private changeWebNotification = async () => {
    let changedSettings: INotificationSettings = {...this.state.setting};
    changedSettings.showNotificationWeb = !changedSettings.showNotificationWeb;
    this.setState({setting: changedSettings});

    await this.props.saveWebSettings!(changedSettings);
    await this.props.getSnackbarSuccess!();
  };

  private setLimit = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let changedSettings = {...this.state.setting};
    if (event.target.value === '') {
      event.target.value = '0';
    }
    changedSettings.limit = event.target.value ? parseFloat(event.target.value) : undefined;
    this.setState({setting: changedSettings});
  };

  private getLimitHeaderText = () => {
    if (this.state.setting.type === NotificationType.Nitrat ) {
      return localized('NitrateLimit');
    }
    if (this.state.setting.type === NotificationType.NitrateNitrogen ) {
      return localized('NitrateNitrogenLimit');
    }
    if (this.state.setting.type === NotificationType.LowBattery) {
      return localized('LowBattery');
    }
  };

  private saveLimitChanges = async () => {
    await this.props.saveLimitSettings!(this.state.setting);
    await this.props.getSnackbarSuccess!();
  };

  private getLimitUnits = () => {
    if (this.state.setting.type === NotificationType.Nitrat) {
      return localized('mgSlashl');
    }
  };

  private getLayoutFromType = () => {
    if (this.state.setting.type === NotificationType.LowBattery) {
      return <Box flexDirection="row" display="flex" className="verticalSpacer2"></Box>;
    }

    if (this.state.setting.type === NotificationType.Nitrat || this.state.setting.type === NotificationType.NitrateNitrogen) {
      return (
        <Box flexDirection="row" display="flex" className="verticalSpacer2">
          <TextField
            id="outlined-basic"
            variant="outlined"
            type="number"
            value={this.state.setting.limit}
            onChange={this.setLimit}
            onBlur={this.saveLimitChanges}
          />
          <div className="units">{this.getLimitUnits()}</div>
        </Box>
      );
    }
  };

  public render() {
    return (
      <Box flexDirection="row" display="flex" className="verticalSpacer1">
        <Box display="flex" justifyContent="left" className="limitInput" flexDirection="column">
          <div className="boldTextLimit">{this.getLimitHeaderText()}</div>

          {this.getLayoutFromType()}
        </Box>
        <Box display="flex" flexDirection="column">
          <div className="boldTextNotification">{localized('Notification')}</div>
          <Box flexDirection="row" display="flex" className="verticalSpacer2">
            <Box flexDirection="row" display="flex" className="verticalSpacer2" onClick={this.changeNotification}>
              <Checkbox
                checked={this.state.setting.emailUserWhenExceedingLimit}
                color="primary"
                className="checkbox"
                size="medium"
              />
              <div className="checkboxName">{localized('Email')}</div>
            </Box>

            <Box flexDirection="row" display="flex" className="verticalSpacer2" onClick={this.changeWebNotification}>
              <Checkbox
                checked={this.state.setting.showNotificationWeb}
                color="primary"
                className="checkbox"
                size="medium"
              />
              <div className="checkboxName">{'Web'}</div>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettingField);
